export class DocumentIntelligenceModel {
    Id: string;
    CompanyId: number;
    CompanyName: string;
    ModelId: string;
    Provider: string;
    ProviderModelId: string;
    DocumentType: string;
    DefaultFormatConverter: string;

    /** An optional JSON specification projecting the provider response onto a domain model. Parble only. */
    MappingSpecification: string;
}
